<template>
    <div v-if="loading" class="q-pa-md row q-gutter-md justify-center"><Spinner/></div>
    <div v-else class="q-mt-sm">
        <p class="text-h4">History</p>
        <p class="text-subtitle2">Click on a card to see details</p>
        <perks-list class="perks-list" :perks="perks" :merchant="merchant"  />
        <div class="row justify-center q-mt-sm" v-if="itemsMax > 1">
          <q-pagination
            v-model="page"
            :max="itemsMax"
            size="md"
            color="primary"
          />
          <q-btn class="full-width" label="Load more..." v-if="show" color="primary" size="md" @click="paginate" />
        </div>
    </div>
</template>

<script>
import router from "@/router";
import PerksList from "@/components/PerksList.vue";
import Spinner from "@/components/Spinner";
import {inject, ref, watch} from "vue";
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

export default {
    name: 'FullPerksList',
    components: {PerksList, Spinner},
    setup() {
        const axios = inject('axios')
        const store = useStore()
        const userId = ref(null)
        const points = ref([])
        const perks = ref([])
        const lastDoc = ref(null)
        const loading = ref(null)
        const show = ref(false)
        const page = ref(1)
        const itemsMax = ref(0)
        const route = useRoute()
        const merchant = ref(route.params.merchant)

        watch(page, (page, oldPage) => {
          getPoints()
        })

        const getPoints = () => { // get the user points
            let owner = (merchant.value) ? `place=${store.getters.statePlace.id}` : `owner=${userId.value}`
            axios.get(`${process.env.VUE_APP_URL}/cards?page=${page.value}&itemsPerPage=5&${owner}&order%5BupdatedAt%5D=desc`,
            {
              headers: {
                'Content-Type': 'application/ld+json',
                'Accept': 'application/ld+json',
              }
            })
            .then(resp => {
              points.value = resp.data['hydra:member']
              perks.value = points.value.map(point => {
                return {
                  id: point.id,
                  place: point.place,
                  ownerId: point.ownerId,
                  name: point.owner.name ?? 'Anonymous',
                  logo: point.place.logo,
                  perks: point.place.perks,
                  points: point.points,
                  message: point.place.message,
                  updatedAt: point.updatedAtAgo
                }
              })
              itemsMax.value = Math.ceil(resp.data['hydra:totalItems'] / 5)
            })
            .catch(err => {
              loading.value = false
            })
        }

        const paginate = () => { // get the user points paginate
            page.value = page.value + 1
            getPoints()
        }

        store.dispatch('verifyLogged')
        .then(resp => {
          userId.value = store.getters.stateUser.id
          getPoints()
        })
        .catch(error => {
          store.commit('setUser', null)
          store.commit('setClearHistory')
          store.commit('clearPlace')
          router.push('/')
        })

        return {loading, lastDoc, points, userId, perks, getPoints, paginate, show, itemsMax, page, merchant}
    },
}
</script>
